var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cities"},_vm._l((_vm.cities),function(city){return _c('div',{key:city.name,staticClass:"wrapper",attrs:{"id":'wrapper-city-' + city.id}},[_c('City',{attrs:{"id":'city-' + city.id,"city":city,"observer":_vm.observer,"activePageId":_vm.activePageId}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }